
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通


const initApply = Number(userInfo.p9_transaction_apply_count);
const initReply = Number(userInfo.p9_transaction_reply_count);


const getTransfer = {
  state: {
    transfer: {
      p9_transaction_apply_count: initApply ? initApply : 0,
      p9_transaction_reply_count: initReply ? initReply : 0,
    },
  },
  actions: {
    transfer({ commit }: any, data: any) {
      commit('SET_Transfer', data);
    },
    async calcApply({ commit }: any, data: any) {
      const user = await $http.get('frontendAdapter/common/info');
      const userInfo = user.data.response;
      const calc = Number(userInfo.p9_transaction_apply_count);
      userInfo.p9_transaction_apply_count = calc;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      commit('SET_Apply', calc);
    },

    async calcReply({ commit }: any, data: any) {
      const user = await $http.get('frontendAdapter/common/info');
      const userInfo = user.data.response;
      const calc = Number(userInfo.p9_transaction_reply_count);
      userInfo.p9_transaction_reply_count = calc;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      commit('SET_Reply', calc);
    },
  },
  mutations: {
    SET_Transfer: (state: any, data: any) => {
      state.transfer = data;
    },
    SET_Apply: (state: any, data: any) => {
      state.transfer.p9_transaction_apply_count = Number(data);
    },
    SET_Reply: (state: any, data: any) => {
      state.transfer.p9_transaction_reply_count = Number(data);
    },
  },
};
export default getTransfer;
